import type {UseFetchOptions} from "#app";

export const useApiProtectionExists = (keyword: string) => {
    return useHttp.get<boolean>('/protection/exists', {
        params: {
            name: keyword
        },
    })
}

export const useApiCertExist = (keyword: string) => {
    return useHttp.get<boolean>('/service/has', {
        params: {
            provider: keyword
        }
    })
}

export type ServiceDto = {
    id: number;
    agent_id: number;
    product_id: number;
    certificate_type_id: number;
    name: string;
    phone: string;
    code: string;
    provider: string;
    number: string;
    start_time: string;
    exit_time: string;
    img: string;
    carrier: string;
    cost_integral: number;
}

export type Service = {
    id: number;
    agentId: number;
    productId: number;
    certificateTypeId: number;
    name: string;
    phone: string;
    code: string;
    provider: string;
    number: string;
    startTime: string;
    exitTime: string;
    img: string;
    carrier: string;
    costIntegral: number;
};

export const useApiFetchCertByNumber = async (number: string) => {
    return useHttp.get<ServiceDto | null>('/service/get-by-number', {
        params: {
            number
        }
    }).then(res => {
        const {data: serviceDto} = res
        let newData = serviceDto.value ? serviceDto2Service(serviceDto.value) : null;
        return {
            ...res,
            data: ref(newData)
        }
    })
}

export type CertShowImgRes = {
    showCertificateUrl: string
    downloadUrl: string
}

export const useApiFetchCertShowImg = (id: number) => {
    return useHttp.get<CertShowImgRes>(`/service/certificate-img-by-id/${id}`)
}

export type PolicyNews = {
    id: number;
    title: string;
    content: string;
}

const policyNewsList: PolicyNews[] = [
    {
        "id": 1,
        "title": "2024年两会李强总理《政府工作报告》：开展“人工智能+”行动",
        "content": "2024年3月份李强总理代表国务院在十四届全国人大二次会议上作的《政府工作报告》提出：“深化大数据、人工智能等研发应用，开展‘人工智能+’行动，打造具有国际竞争力的数字产业集群。”人工智能是新质生产力的重要驱动力和新引擎，加快发展新一代人工智能，对于深入推动高质量发展具有重要意义。当前，人工智能存在着数据基础还不够全、技术实力还不够硬、产业发展还不够强、人才支撑还不够牢、治理体系还不够优的问题，急需推进数据链、技术链、产业链、人才链、机制链“五链融合”，以助推“人工智能+”行动的科学实施，更好赋能新质生产力发展。",
    },
    {
        "id": 2,
        "title": "2025年国务院印发《国务院关于深入实施“人工智能+”行动的意见》",
        "content": `2025年8月21日国务院印发《关于深入实施“人工智能+”行动的意见》（以下简称《意见》），提出加快实施“人工智能+”科学技术、“人工智能+”产业发展、“人工智能+”消费提质、“人工智能+”民生福祉、“人工智能+”治理能力、“人工智能+”全球合作等6大重点行动，强化8项基础支撑能力，推动人工智能与经济社会各行业各领域广泛深度融合。《意见》提出，到2027年，率先实现人工智能与6大重点领域广泛深度融合，新一代智能终端、智能体等应用普及率超70%，智能经济核心产业规模快速增长，人工智能在公共治理中的作用明显增强，人工智能开放合作体系不断完善。到2030年，我国人工智能全面赋能高质量发展，新一代智能终端、智能体等应用普及率超90%，智能经济成为我国经济发展的重要增长极，推动技术普惠和成果共享。到2035年，我国全面步入智能经济和智能社会发展新阶段，为基本实现社会主义现代化提供有力支撑。`,
    },
    {
        "id": 3,
        "title": "2026年两会李强总理《政府工作报告》：打造智能经济新形态",
        "content": `2026年3月5日，《2026年国务院政府工作报告》对“打造智能经济新形态”作出安排，从深化拓展“人工智能+”，推动重点行业领域人工智能商业化规模化应用，培育智能原生新业态新模式，到健全数据要素基础制度，完善人工智能治理，勾勒出我国智能经济高质量发展的路线图。报告指出要以人工智能为核心驱动力，通过“人工智能 ”深度赋能千行百业而形成的新型经济形态。其核心举措包括深化拓展“人工智能+”行动，推广新一代智能终端与智能体；实施超大规模智算集群、算电协同等新型基础设施工程；深化数据资源开发利用，健全数据要素制度；并完善人工智能治理体系。该形态旨在系统性重塑生产、分配、交换、消费全流程，培育智能原生业态，是发展新质生产力、推动经济高质量发展的重要战略部署。`,
    },
    {
        "id": 4,
        "title": "两会快评丨深化拓展“人工智能+”正当其时",
        "content": "从2024年到2026年，政府工作报告连续3年部署“人工智能+”，今年报告再度提及“人工智能+”，将去年的“持续推进”升级为“深化拓展”。看似简单的用词变化，实则蕴含着战略重心的迁移。如果说过去两年是“播种”与“启蒙”，那么2026年无疑是“深耕”与“收获”的元年。2025年我国人工智能核心产业规模超过1.2万亿元，企业数量超过6200家。尤为值得注意的是，截至去年底，规上制造业企业人工智能技术应用普及率已超30%。这30%的普及率，是AI走出象牙塔、在实体经济中扎下根来的铁证。今年，工信部提出要推动AI电脑、智能家居、脑机接口、智能农业机械等服务民生和社会需求，从消费端到产业端全面开花。深化拓展“人工智能+”，不仅是应对当前经济压力的技术手段，更是关乎国家长远竞争力的战略抉择。",
    },
    {
        "id": 5,
        "title": "新一代人工智能将带来经济发展新增量",
        "content": `“从自身发展来看，新一代人工智能将带来经济发展新增量。”中国电子信息产业发展研究院未来产业研究中心所长蒲松涛表示，大模型和智能体有望催生新业态，预计未来几年，以信息服务为主流的大模型服务将进一步走入人类生产生活中，成为新型的服务业态。此外，数字人、智能系统等“软智能体”有望带来全新的人工智能服务体验；AI汽车、人形机器人等“硬智能体”也正在从实验室走向实际应用，人形机器人在家政服务、工业制造等领域的应用备受关注。
　　人工智能与千行百业更深融合，将让技术变量成为产业增量、让场景优势转化为竞争优势。中国工业互联网研究院智能化研究所所长顾维玺认为，要把人工智能作为发展新质生产力的关键引擎，深化“人工智能+”融合应用，面向制造业、农业、服务业以及民生服务、城市治理等重点领域，拓展规模化应用场景，以场景创新带动技术迭代、产业升级和模式创新。构建需求牵引供给、供给创造需求的良性循环生态，强化供需撮合、项目孵化、投融资对接等一体化支撑，助力人工智能技术与实体经济深度融合，提升产业整体智能化水平。
`,
    },
    {
        "id": 6,
        "title": "人工智能产业规模持续快速增长",
        "content": `国家系统布局“人工智能+”，六大重点行动和八大基础支撑能力。
人工智能产业规模连续多年保持20%以上增长，独角兽企业全球占比约26%.。
截至2026年3月，已发布1509个大模型，居世界首位。累计有796款生成式人工智能服务完成备案。
中国人工智能专利约 52.96 万件，累计申请量超 180 万件。
外交部 2026 年 3 月 26 日例行记者会正式确认：中国是全球 AI 专利最大拥有国，占全球人工智能专利总量约 60%，为全球最大 AI 专利拥有国。
`,
    }
]
export const useApiFetchPolicyNews = async () => {
    return {
        data: ref(policyNewsList)
    }
}

export type NewsListForm = {
    page: number
    size: number
}
/*
* 这个是后端 Article
* */
export type News = {
    id: number
    name: string
    img: string
    time: string
    text: string
    num: number
    price: number
}

export const uesApiFetchNewsList = (params: NewsListForm, opts?: UseFetchOptions<any>) => {
    return useHttp.get<{
        list: News[]
        total: number
    }>(`/article/list`, {
        ...opts,
        params,
    })
}

export const useApiFetchNewsInfo = (id: number) => {
    return useHttp.get<News>(`/article/${id}`)
}

export const useApiFetchProjectExistByName = (name: string) => {
    return useHttp.get<boolean>(`/project/exists`, {
        params: {
            name
        }
    })
}

export const useApiFetchAgentExistByName = (name: string) => {
    return useHttp.get<boolean>(`/agent/exists`, {
        params: {
            name
        }
    })
}

export type PolicyDocument = {
    id: number;
    img: string;
    bigImg: string;
}

export async function useApiFetchPolicyDocumentList() {
    const config = useRuntimeConfig();
    const baseUrl = config.app.baseURL
    const list: PolicyDocument[] = [
        {
            id: 1,
            img: 'policy1.jpg',
            bigImg: 'policy1_big.jpg'
        },
        {
            id: 2,
            img: 'policy2.jpg',
            bigImg: 'policy2_big.jpg'
        },
        {
            id: 3,
            img: 'policy3.jpg',
            bigImg: 'policy3_big.jpg'
        },
        {
            id: 4,
            img: 'policy4.jpg',
            bigImg: 'policy4_big.jpg'
        },
        {
            id: 5,
            img: 'policy5.jpg',
            bigImg: 'policy5_big.jpg'
        },
    ].map(item => {
        const img = `${baseUrl}img/policy/data/${item.img}`;
        const bigImg = `${baseUrl}img/policy/data/${item.bigImg}`

        return {
            ...item,
            img,
            bigImg
        }
    })


    return {
        data: ref(list)
    };
}

export type Case = {
    id: number
    name: string,
    content: string,
    img: string,
    time: string,
    url: string
}

export type CasePageForm = {
    page: number
    size: number
}

export function useApiFetchCaseList(params: CasePageForm) {
    return useHttp.get<{
        list: Case[],
        total: number
    }>('/cases/page', {
        params
    })
}